/**
 * 作品（1エピソード）の進捗率を計算する
 * @param resumePoint 秒
 * @param duration 秒
 * @returns 進捗率（%）
 */
export const calculatePlayProgressRate = (resumePoint = 0, duration = 0) => {
  if (!resumePoint || !duration) return 0;
  // 元データの不具合で進捗率が100%を超えるとUIが崩れることへの対応
  return Math.min((resumePoint / duration) * 100, 100);
};
